"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../../constants");
const LogoutMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 24"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(-1.000000, 0.000000)"
}, _react.default.createElement("path", {
  d: "M22.6035534,0.5 L22.6035534,23.5 L9.60355339,23.5 L9.60355339,22.5 L21.6035534,22.5 L21.6035534,1.5 L9.60355339,1.5 L9.60355339,0.5 L22.6035534,0.5 Z M7.10355339,6.29289322 L7.81066017,7 L3.31044661,11.5 L17.1035534,11.5 L17.1035534,12.5 L3.31044661,12.5 L7.81066017,17 L7.10355339,17.7071068 L1.39644661,12 L7.10355339,6.29289322 Z"
}))));
const LogoutPrizm = ({
  fill
}) => _react.default.createElement("svg", {
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32",
  fill: fill
}, _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(5.000000, 6.000000)"
}, _react.default.createElement("path", {
  d: "M19.024769,-0.000492453211 C19.0906742,0.00106371088 19.1554909,0.00922223577 19.2184424,0.0234233192 C19.2231428,0.0249773595 19.227756,0.0260403613 19.2323569,0.027135155 C19.2523794,0.0314866827 19.2723059,0.03694891 19.2920084,0.0430113924 C19.3106919,0.0490002676 19.3292537,0.0552665467 19.3475626,0.0620535838 C19.7205207,0.201304838 20,0.558734812 20,1 L20,1 L20,19 C20,19.4304304 19.7245699,19.8125693 19.3162278,19.9486833 L19.3162278,19.9486833 L13.3162278,21.9486833 C12.6686967,22.164527 12,21.6825577 12,21 L12,21 L12,19.9995075 L3,20 C2.48716416,20 2.06449284,19.6139598 2.00672773,19.1166211 L2,19 L2,16 C2,15.4477153 2.44771525,15 3,15 C3.51283584,15 3.93550716,15.3860402 3.99327227,15.8833789 L4,16 L4,18 L12,17.9995075 L12,3 C12,2.60869963 12.2276282,2.25730964 12.5758086,2.09438994 L12.6837722,2.0513167 L12.836,1.99950755 L4,2 L4,4 C4,4.51283584 3.61395981,4.93550716 3.11662113,4.99327227 L3,5 C2.48716416,5 2.06449284,4.61395981 2.00672773,4.11662113 L2,4 L2,1 C2,0.487164161 2.38604019,0.0644928393 2.88337887,0.00672773133 L3,2.16840434e-19 Z M18,2.387 L14,3.72 L14,19.612 L18,18.279 L18,2.387 Z M6.61289944,6.20970461 L6.70710678,6.29289322 L9.70710678,9.29289322 C10.0675907,9.65337718 10.0953203,10.2206082 9.79029539,10.6128994 L9.70710678,10.7071068 L6.70710678,13.7071068 C6.31658249,14.0976311 5.68341751,14.0976311 5.29289322,13.7071068 C4.93240926,13.3466228 4.90467972,12.7793918 5.20970461,12.3871006 L5.29289322,12.2928932 L6.585,10.9995075 L1,11 C0.44771525,11 0,10.5522847 0,10 C0,9.48716416 0.38604019,9.06449284 0.883378875,9.00672773 L1,9 L6.585,8.99950755 L5.29289322,7.70710678 C4.93240926,7.34662282 4.90467972,6.77939176 5.20970461,6.38710056 L5.29289322,6.29289322 C5.65337718,5.93240926 6.22060824,5.90467972 6.61289944,6.20970461 Z"
}))));
const Logout = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(LogoutMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(LogoutPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(Logout);